import MultiStateDropdown, {
  type MultiStateDropdownOption,
} from "components/dropdowns/multiStateDropdown/MultiStateDropdown";
import GroupsOverview from "../Groups/GroupsOverview/GroupsOverview";
import TemplatesOverview from "../GroupTemplate/Overview/TemplatesOverview";
import { faBuildingUser, faUsers } from "@fortawesome/pro-solid-svg-icons";
import { useNavigate } from "react-router";
import { GroupContentTypesEnum } from "./constants";
import { TemplatesOverviewColumns } from "features/People/GroupTemplate/Overview/columnOptions";

const contentOptions: MultiStateDropdownOption<GroupContentTypesEnum>[] = [
  {
    label: GroupContentTypesEnum.Groups,
    icon: faUsers,
  },
  {
    label: GroupContentTypesEnum.Templates,
    icon: faBuildingUser,
  },
];

const routes = {
  [GroupContentTypesEnum.Groups]: "..",
  [GroupContentTypesEnum.Templates]: "inherited",
};

const hiddenColumns: TemplatesOverviewColumns[] = [TemplatesOverviewColumns.Customers, TemplatesOverviewColumns.Users];

/* istanbul ignore next */
export const GroupsSwitcher = (props: { ctx: GroupContentTypesEnum }) => {
  const navigate = useNavigate();

  const handleChangeContext = (newContext: GroupContentTypesEnum) => {
    navigate(routes[newContext]);
  };

  const switcher = () => {
    return (
      <MultiStateDropdown
        className="groups-segmentation-dropdown"
        options={contentOptions}
        defaultOption={contentOptions.find((option) => option.label === props.ctx)!}
        onContextChange={handleChangeContext}
        defaultValue={props.ctx}
      />
    );
  };

  const components = {
    [GroupContentTypesEnum.Groups]: <GroupsOverview renderContentSwitcher={switcher} />,
    [GroupContentTypesEnum.Templates]: (
      <TemplatesOverview renderContentSwitcher={switcher} withCreate={false} hiddenColumns={hiddenColumns} />
    ),
  };

  return components[props.ctx];
};
